// components
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import Link from '@/components/utilities/SmartLink';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

// utilities
import { getImagePath } from '@/utils/images';

const CaseStudiesBlock = ({ caseStudiesBlockContent: content }) => {
  return (
    <div className="mx-auto my-10 w-[90vw] xl:w-(--container-width)">
      <div className="-ml-6 flex flex-wrap gap-y-6">
        {(content || []).map((item, index) => (
          <VisibleLoading key={item.id} delay={(index + 1) * 100}>
            {({ ref, className }) => <CaseStudy innerRef={ref} className={className} caseStudy={item} />}
          </VisibleLoading>
        ))}
      </div>
    </div>
  );
};
export default CaseStudiesBlock;

const CaseStudy = ({ innerRef, className, caseStudy }) => {
  return caseStudy.width === 'full' ? (
    <div ref={innerRef} className={`basis-full ${className || ''}`.trim()}>
      <div className="items-left ml-6 flex h-full rounded-3xl bg-white p-6 shadow-2xl/15 xl:items-center xl:p-12">
        <div className="flex flex-col items-center xl:items-start">
          <div className="mb-6 h-[100px] max-w-[160px] xl:mb-10">
            {caseStudy.logo && (
              <Image
                src={getImagePath(caseStudy.logo)}
                alt={caseStudy.title}
                width={caseStudy.logo.width}
                height={caseStudy.logo.height}
                sizes="160px"
                className="h-full w-full object-contain"
              />
            )}
          </div>

          <h4 className="mb-6 w-full">{caseStudy.title}</h4>

          <p className="mb-6 w-full max-w-[380px] xl:mb-10">{caseStudy.text}</p>

          <div className="flex w-full flex-wrap gap-2">
            {caseStudy.buttons.map((button) => (
              <Button
                key={button.id}
                variant={button.variant}
                size={button.size}
                asChild={true}
                className="basis-full xl:basis-auto"
              >
                <Link href={button.url || ''}>
                  <Icon type={button.icon} /> {button.label}
                </Link>
              </Button>
            ))}
          </div>
        </div>

        <div className="hidden flex-1 items-center justify-end xl:flex">
          {caseStudy.image && (
            <Image
              src={getImagePath(caseStudy.image)}
              alt={caseStudy.title}
              width={caseStudy.image.width}
              height={caseStudy.image.height}
              sizes="(min-width: 1280px) 600px, 0px"
              className="h-full max-h-[400px] object-contain object-right"
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <div ref={innerRef} className={`basis-full xl:basis-1/3 ${className || ''}`.trim()}>
      <div className="ml-6 flex h-full flex-col items-center rounded-3xl bg-white p-6 shadow-2xl/15">
        <div className="mb-6 h-[150px] max-w-[300px]">
          {caseStudy.logo && (
            <Image
              src={getImagePath(caseStudy.logo)}
              alt={caseStudy.title}
              width={caseStudy.logo.width}
              height={caseStudy.logo.height}
              sizes="300px"
              className="h-full w-full object-contain"
            />
          )}
        </div>

        <div className="mb-6 flex-1">
          <h6 className="mb-6 w-full">{caseStudy.title}</h6>

          <p className="w-full">{caseStudy.text}</p>
        </div>

        <div className="flex w-full flex-wrap gap-2">
          {caseStudy.buttons.map((button) => (
            <Button
              key={button.id}
              variant={button.variant}
              size={button.size}
              asChild={true}
              className="basis-full xl:basis-auto"
            >
              <Link href={button.url || ''}>
                <Icon type={button.icon} /> {button.label}
              </Link>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
